import * as React from 'react';
import { Modal, Button, Radio, DatePicker, Form } from 'antd';
import moment from 'moment';
import {disableInquiryClosingDateUtil, disableInquiryClosingTimeUtil} from "../InquiryUtils";
import { tokens } from 'src/design-system';

const FormItem = Form.Item;
class QuoteRejectionModal extends React.PureComponent<any, any> {

  handleConfirm = () => {
    const {handleOk} = this.props;
    const {validateFields, getFieldValue} = this.props.form;
    validateFields((err, values) => {
      if (err) return;
      if (getFieldValue('reopenInquiry') === 'INQUIRY_REOPENED') {
        handleOk(getFieldValue('inquiryReopenDate'));
      } else {
        handleOk();
      }
    });
  }

  render() {
    const {
      visible,
      handleCancel,
      loading,
      options,
      form: { getFieldDecorator, getFieldValue },
    } = this.props;
    const isDisabled = options && !getFieldValue('reopenInquiry');
    return (
      <Modal
        title="Quote Rejection"
        visible={visible}
        onOk={this.handleConfirm}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={this.handleConfirm}
            loading={loading}
            style={{
              background: isDisabled ? '#999999' : tokens.colors.primary,
              border: tokens.colors.primary,
              color: tokens.colors.bgWhite,
            }}
            disabled={isDisabled}
          >
            Decline Bid
          </Button>,
        ]}
      >
        {options ? (
          <p>Please select one of the following in order to proceed with bid decline:</p>
        ) : (
          <p>Are you sure, you want to decline the quote?</p>
        )}
        <FormItem style={{ marginBottom: '0px' }}>
          {getFieldDecorator('reopenInquiry', {
            initialValue: '',
          })(
            <Radio.Group
              onChange={(e) => this.setState({ closeInquiry: e.target.value })}
            >
              {options?.map((option) => (
                <Radio
                  key={options.key}
                  value={option.key}
                  style={{ marginTop: '10px', fontSize: `${tokens.fontSize.body}px`, display: 'flex' }}
                >
                  {option.label}
                </Radio>
              )) || []}
            </Radio.Group>
          )}
        </FormItem>
        {getFieldValue('reopenInquiry') === 'INQUIRY_REOPENED' && (
          <FormItem style={{ width: '60%' }}>
            {getFieldDecorator('inquiryReopenDate', {
              rules: [{ required: true, message: 'Inquiry closing date is required' }],
              initialValue: moment().endOf('day').add(2, 'day'),
            })(
              <DatePicker
                showTime
                disabledDate={disableInquiryClosingDateUtil}
                disabledTime={disableInquiryClosingTimeUtil}
                allowClear={false}
                format="DD MMM YYYY | HH:mm"
                style={{ width: '80%', marginBottom: '20px' }}
                placeholder="New Inquiry Closing Date"
              />
            )}
          </FormItem>
        )}
      </Modal>
    );
  }
}

export default Form.create<any>()(QuoteRejectionModal);